



























import Vue from 'vue'
import Card from '@/components/Card.vue'
import { getProducts } from '@/api/Topup/topup.api'
import Distribution from './Distribution.vue'
export default Vue.extend({
  components: {
    appCard: Card,
    appDistribution: Distribution,
  },
  data() {
    return {
      tab: 0,
      tabs: [] as number[],
      loading: true,
    }
  },
  async mounted() {
    try {
      this.loading = true
      const response = await getProducts({ limit: 100 })
      this.tabs = response.data.results.map(product => product.amount)
    } finally {
      this.loading = false
    }
  },
})
